import { render, staticRenderFns } from "./view-course.html?vue&type=template&id=af9f14d0&scoped=true&"
import script from "./view-course.js?vue&type=script&lang=js&"
export * from "./view-course.js?vue&type=script&lang=js&"
import style0 from "./view-course.scss?vue&type=style&index=0&id=af9f14d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9f14d0",
  null
  
)

export default component.exports